import { render, staticRenderFns } from "./shipments-sidebar.vue?vue&type=template&id=3e3ef3ab&scoped=true&"
import script from "./shipments-sidebar.ts?vue&type=script&lang=ts&"
export * from "./shipments-sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./shipments-sidebar.scss?vue&type=style&index=0&id=3e3ef3ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3ef3ab",
  null
  
)

export default component.exports